import { Card } from "@yleisradio/areena-types";

import { SetPlayingRecommendation } from "../components/recommendations/recommendationTypes";
import { trackEvent } from "../helpers/analyticsHelpers";
import { PlayerUpdateEvent } from "../types/public";

import { getYleIdFromCardOrThrow } from "./areenaApi";
import { getRecommendationUrl } from "./areenaLinks";

const trackRecommendationLink = (
  programId: string,
  index: number,
  mainRecommendation = false
) =>
  trackEvent("player.recommendation.play", {
    yle_referrer: `player-recommendation|${programId}|place_${
      mainRecommendation ? "main" : index + 1
    }`
  });

export const playRecommendation = ({
  index,
  language,
  mainRecommendation = false,
  playProgram,
  programId,
  recommendation,
  setPlayingRecommendation,
  update
}: {
  index: number;
  language: string;
  mainRecommendation?: boolean;
  playProgram: boolean;
  programId: string;
  recommendation: Card;
  setPlayingRecommendation: SetPlayingRecommendation;
  update: PlayerUpdateEvent;
}) => {
  trackRecommendationLink(programId, index, mainRecommendation);

  const recommendationProgramId = getYleIdFromCardOrThrow(recommendation);

  if (playProgram) {
    setPlayingRecommendation(index);
    update({
      autoplay: true,
      programId: recommendationProgramId
    });
  } else {
    window.location.assign(
      getRecommendationUrl({
        index,
        language,
        programId: recommendationProgramId
      })
    );
  }
};
